import { FormikHelpers } from "formik";
import { useCreateDCompany } from "./api/createDCompany";
import CreateDCompanyForm from "./CreateDCompanyForm";


const CreateDCompany = ({handleCloseModal}: CreateDCompanyProps)  => {
  const createDCompanyMutation = useCreateDCompany({data: {}});

  const initialValues: ICreateDCompanyForm = {
    description: "",
    placeID: "",
    unID: "",
    sapCode: "",
    isEmporiki: false,
    isCiti: false,
    modemID: "",
    modemPort: "",
  };

  const handleSubmit = async (values: ICreateDCompanyForm, { setSubmitting }: FormikHelpers<ICreateDCompanyForm>): Promise<void> => {
    try {
      await createDCompanyMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <CreateDCompanyForm initialValues={initialValues}  onSubmit={handleSubmit} />
  )
}

interface CreateDCompanyProps {
  handleCloseModal: () => void;
}

export default CreateDCompany;